import TridotOption from './TridotOption';

export default TridotOption;
